import SidebarItem from "../../entities/SidebarItem";
import i18n from "../../i18n";
import { roles } from "../../util/config/roles";

const getSidebarItems = (
    allowedItems: string[],
    isManager: boolean = false
): ReadonlyArray<SidebarItem> => {
    const role = roles();

    const sidebarItems: SidebarItem[] = [
        {
            to: "/Dashboard-employee",
            isExternalLink: false,
            text: i18n.t("common:sidebar.dashboardEmployee"),
            itemId: "22"
        },
        {
            to: "/WorkflowTasks",
            isExternalLink: false,
            text: i18n.t("common:sidebar.noticesAndTasks"),
            itemId: "9"
        },
        {
            to: "/Payroll",
            isExternalLink: false,
            text: i18n.t("common:sidebar.payroll"),
            itemId: "10"
        },
        {
            to: "/Applications",
            isExternalLink: false,
            text: i18n.t("common:sidebar.applications"),
            itemId: "11"
        },
        {
            to: "/Documents",
            isExternalLink: false,
            text: i18n.t("common:sidebar.documents"),
            itemId: "7"
        },
        {
            to: "/Contracts",
            isExternalLink: false,
            text: i18n.t("common:sidebar.contracts"),
            itemId: "666"
        },
        {
            to: "/Contacts",
            isExternalLink: false,
            text: i18n.t("common:sidebar.persons"),
            itemId: "3"
        },
        {
            to: "/staffLogicApp",
            isExternalLink: true,
            text: i18n.t("common:sidebar.worktimeAndAbsences"),
            itemId: "2"
        }
    ];

    let filteredSidebarItems = sidebarItems.filter(item =>
        allowedItems?.includes(item.itemId)
    );

    if (role.isSuperAdminOrAdmin) {
        return [
            // {
            //     to: "/Impersonate",
            //     isExternalLink: false,
            //     text: i18n.t("common:sidebar.impersonate"),
            //     itemId: "0"
            // },
            {
                to: "/Settings",
                isExternalLink: false,
                text: i18n.t("pages:settings.title"),
                itemId: "99"
            }
        ];
    }

    // return filteredSidebarItems;

    return [
        {
            to: "/",
            isExternalLink: false,
            text: i18n.t("candidate_portal:sidebarLinks.contracts"),
            itemId: "999"
        }
    ];
};

export default getSidebarItems;
